import React, { useState, useEffect } from "react";
import { get, post } from "../../../services/api";
import { toast } from "react-toastify";

function InterviewSchedule() {
  const token = localStorage.getItem("token");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");
  const organizationId = localStorage.getItem("organizationId");
  const [applicants, setApplicants] = useState([]);
  const [formData, setFormData] = useState({
    applicantId: "",
    interviewDate: "",
    interviewTime: "",
    mode: "Onsite",
    locationOrLink: "",
    interviewerName: "",
    agenda: "",
  });

  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchApplicants();
  }, []);

  const fetchApplicants = async () => {
    try {
      const response = await get(
        `Onboarding/applicants?organizationId=${organizationId}&CenterId=${savedCenterId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.success) {
        // Filter only shortlisted or screening applicants
        // const eligibleApplicants = (response.data || []).filter(
        //   (a) =>
        //     a.status === "Shortlisted" ||
        //     a.status === "Screening" ||
        //     a.status === "Interview" ||
        //     a.status === "Applied"||
        //     a.status === "New"
        // );
        setApplicants(response.data);
      }
    } catch (error) {
      console.error("Error fetching applicants:", error);
    }
  };

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSchedule = async () => {
    if (
      !formData.applicantId ||
      !formData.interviewDate ||
      !formData.interviewTime
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);

      const response = await post(
        "Onboarding/interviews",
        {
          applicantId: parseInt(formData.applicantId),
          interviewDate: `${formData.interviewDate}T${formData.interviewTime}:00`,
          mode: formData.mode,
          locationOrLink: formData.locationOrLink,
          interviewerName: formData.interviewerName,
          agenda: formData.agenda,
          centerId: savedCenterId,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.success) {
        setShowSuccess(true);
        toast.success("Interview scheduled successfully!");
        setTimeout(() => setShowSuccess(false), 3000);
        handleReset();
      }
    } catch (error) {
      console.error("Error scheduling interview:", error);
      toast.error(
        error.response?.data?.message || "Failed to schedule interview",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      applicantId: "",
      interviewDate: "",
      interviewTime: "",
      mode: "InPerson",
      locationOrLink: "",
      interviewerName: "",
      agenda: "",
    });
    setShowSuccess(false);
  };

  return (
    <div className="row g-3">
      <div className="col-md-12">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Interview Schedule</h4>
        </div>

        <div className="card">
          <div className="card-body">
            <h5 className="mb-3 fs-9 border-bottom pb-2">
              Schedule Interview Details
            </h5>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">
                  Applicant<span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={formData.applicantId}
                  onChange={(e) => handleChange("applicantId", e.target.value)}
                >
                  <option value="">-- Select Applicant --</option>
                  {applicants.map((applicant) => (
                    <option key={applicant.id} value={applicant.id}>
                      {applicant.fullName} - {applicant.positionTitle} (
                      {applicant.status})
                    </option>
                  ))}
                </select>
                {applicants.length === 0 && (
                  <small className="text-muted">
                    No eligible applicants found
                  </small>
                )}
              </div>

              <div className="col-md-3">
                <label className="form-label">
                  Interview Date<span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={formData.interviewDate}
                  onChange={(e) =>
                    handleChange("interviewDate", e.target.value)
                  }
                />
              </div>

              <div className="col-md-3">
                <label className="form-label">
                  Time<span className="text-danger">*</span>
                </label>
                <input
                  type="time"
                  className="form-control"
                  value={formData.interviewTime}
                  onChange={(e) =>
                    handleChange("interviewTime", e.target.value)
                  }
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Interviewer Name</label>
                <input
                  className="form-control"
                  placeholder="e.g., HR Manager"
                  value={formData.interviewerName}
                  onChange={(e) =>
                    handleChange("interviewerName", e.target.value)
                  }
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Mode</label>
                <select
                  className="form-control"
                  value={formData.mode}
                  onChange={(e) => handleChange("mode", e.target.value)}
                >
                  <option value="Onsite">In Person</option>{" "}
                  {/* ✅ Value is "Onsite" */}
                  <option value="Online">Online</option>
                  <option value="Phone">Phone</option>
                </select>
              </div>

              <div className="col-md-4">
                <label className="form-label">Location / Link</label>
                <input
                  className="form-control"
                  placeholder="Office address or video call link"
                  value={formData.locationOrLink}
                  onChange={(e) =>
                    handleChange("locationOrLink", e.target.value)
                  }
                />
              </div>

              <div className="col-12">
                <label className="form-label">Agenda / Remarks</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Interview topics, documents required..."
                  value={formData.agenda}
                  onChange={(e) => handleChange("agenda", e.target.value)}
                />
              </div>
            </div>

            <div className="mt-4 d-flex gap-2">
              <button
                type="button"
                className="btn btn-success"
                onClick={handleSchedule}
                disabled={loading}
              >
                <i className="fas fa-check me-1"></i>
                {loading ? "Scheduling..." : "Schedule Interview"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={handleReset}
              >
                <i className="fas fa-redo me-1"></i>
                Reset
              </button>
            </div>

            {showSuccess && (
              <div className="alert alert-success mt-3">
                <i className="fas fa-check-circle me-2"></i>
                Interview scheduled successfully! Applicant status updated.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default InterviewSchedule;
